"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ResultsCardMessages = {
  EN: ['Too bad, practice more!', 'Not bad.', 'Well done!', 'Really well done!', 'Perfect!'],
  EN2: ['Too bad, practice more!', 'Not bad.', 'Well done!', 'Really well done!', 'Perfect!'],
  SQ: ['Sa keq, vazhdo të ushtrohesh!', 'Jo keq.', 'Të lumtë!', 'Shumë mirë!', 'Përsosur!'],
  AR: ['للأسف، واصل التدريب!', 'ليس سيئًا.', 'أحسنت!', 'أحسنت جدًا!', 'ممتاز!'],
  BG: ['Жалко, продължавай да се упражняваш!', 'Не е зле.', 'Браво!', 'Много добре!', 'Перфектно!'],
  ZH: ['真可惜，继续练习！', '不错。', '做得好！', '做得非常好！', '完美！'],
  ZH2: ['真可惜，繼續練習！', '不錯。', '做得好！', '做得非常好！', '完美！'],
  HR: ['Šteta, nastavi vježbati!', 'Nije loše.', 'Bravo!', 'Odlično!', 'Savršeno!'],
  CS: ['Škoda, procvičuj dál!', 'To není špatné.', 'Dobrá práce!', 'Skvělá práce!', 'Perfektní!'],
  DA: ['Ærgerligt, bliv ved med at øve dig!', 'Ikke dårligt.', 'Godt klaret!', 'Rigtig godt klaret!', 'Perfekt!'],
  NL: ['Jammer, blijf oefenen!', 'Niet slecht.', 'Goed gedaan!', 'Heel goed gedaan!', 'Perfect!'],
  FI: ['Harmi, jatka harjoittelua!', 'Ei hassumpaa.', 'Hyvin tehty!', 'Todella hyvin tehty!', 'Täydellistä!'],
  FR: ['Dommage ! Entraîne-toi encore.', 'Pas mal !', 'Bien joué !', 'Super, bon travail !', 'Parfait !'],
  DE: ['Schade, übe weiter!', 'Nicht schlecht.', 'Gut gemacht!', 'Super gut gemacht!', 'Perfekt!'],
  EL: ['Κρίμα, συνέχισε την εξάσκηση!', 'Όχι άσχημα.', 'Μπράβο!', 'Πολύ καλή δουλειά!', 'Τέλεια!'],
  IW: ['חבל, כדאי להמשיך לתרגל!', 'לא רע.', 'כל הכבוד!', 'עבודה מצוינת!', 'מושלם!'],
  HI: ['अफ़सोस, अभ्यास जारी रखो!', 'बुरा नहीं है।', 'शाबाश!', 'बहुत बढ़िया!', 'एकदम सही!'],
  HU: ['Kár, gyakorolj tovább!', 'Nem rossz.', 'Szép munka!', 'Nagyon szép munka!', 'Tökéletes!'],
  IN: ['Sayang sekali, terus berlatih!', 'Lumayan.', 'Bagus!', 'Bagus sekali!', 'Sempurna!'],
  IT: ['Peccato, continua a esercitarti!', 'Non male.', 'Ben fatto!', 'Davvero ben fatto!', 'Perfetto!'],
  JA: ['残念、練習を続けよう！', '悪くないね。', 'よくできました！', 'とてもよくできました！', '完璧！'],
  KO: ['아쉽네요, 계속 연습해 보세요!', '괜찮아요.', '잘했어요!', '정말 잘했어요!', '완벽해요!'],
  NO: ['Synd, fortsett å øve!', 'Ikke verst.', 'Bra jobbet!', 'Veldig bra jobbet!', 'Perfekt!'],
  FA: ['حیف شد، به تمرین ادامه بده!', 'بد نیست.', 'آفرین!', 'خیلی خوب بود!', 'عالی!'],
  PL: ['Szkoda, ćwicz dalej!', 'Nieźle.', 'Dobra robota!', 'Świetna robota!', 'Idealnie!'],
  PT2: ['Que pena, continue praticando!', 'Nada mal.', 'Muito bem!', 'Mandou muito bem!', 'Perfeito!'],
  PT: ['Que pena, continua a praticar!', 'Nada mau.', 'Muito bem!', 'Mesmo muito bem!', 'Perfeito!'],
  RO: ['Păcat, continuă să exersezi!', 'Nu e rău.', 'Bravo!', 'Foarte bine!', 'Perfect!'],
  RU: ['Жаль, продолжай тренироваться!', 'Неплохо.', 'Молодец!', 'Отличная работа!', 'Идеально!'],
  SR: ['Штета, настави да вежбаш!', 'Није лоше.', 'Браво!', 'Одлично!', 'Савршено!'],
  SK: ['Škoda, precvičuj ďalej!', 'Nie je to zlé.', 'Dobrá práca!', 'Skvelá práca!', 'Perfektné!'],
  ES: ['¡Qué lástima, sigue practicando!', 'Nada mal.', '¡Bien hecho!', '¡Muy bien hecho!', '¡Perfecto!'],
  SV: ['Synd, fortsätt öva!', 'Inte illa.', 'Bra jobbat!', 'Riktigt bra jobbat!', 'Perfekt!'],
  TR: ['Ne yazık, pratik yapmaya devam et!', 'Fena değil.', 'Aferin!', 'Çok iyi iş çıkardın!', 'Mükemmel!'],
  UK: ['Шкода, продовжуй тренуватися!', 'Непогано.', 'Молодець!', 'Чудова робота!', 'Ідеально!'],
  UZ: ['Afsus, mashq qilishda davom et!', 'Yomon emas.', 'Barakalla!', 'Juda yaxshi!', 'Mukammal!'],
  VI: ['Tiếc quá, hãy tiếp tục luyện tập!', 'Không tệ.', 'Làm tốt lắm!', 'Làm rất tốt!', 'Hoàn hảo!']
};
var _default = exports["default"] = ResultsCardMessages;